/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./styles.css";
import { NavBar } from "../Navbar";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import * as account from "../../_redux/accountRedux";
import CreditBox from "./CreditBox";
export function Credit(props) {
  return (
    <>
      {/* begin::Dashboard */}

      {/* begin::Row */}
      <div className="row">
        <div className="col-xl-12">
          <NavBar className="gutter-b" />
        </div>
        <div className="col-xl-12">
          <CreditBox />
        </div>
      </div>
    </>
  );
}
export default injectIntl(connect(null, account.actions)(Credit));
